export default __webpack_public_path__ + "static/media/the-reason.dfce87f6.jpg";